import React, { useRef } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { BonusSection } from '../components/BonusSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  const purchaseRef = useRef<HTMLDivElement>(null);
  const scrollToPurchase = () => {
    purchaseRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#fafaf9] font-sans text-[#1a1a1a]" data-id="element-178">
      <UrgencyBar data-id="element-179" />

      <main data-id="element-180">
        <HeroSection onScrollToPurchase={scrollToPurchase} data-id="element-181" />
        <PainSection data-id="element-182" />
        <SolutionSection data-id="element-183" />
        <BenefitsSection data-id="element-184" />
        <BonusSection onScrollToPurchase={scrollToPurchase} data-id="element-185" />

        <div ref={purchaseRef} data-id="element-186">
          <PurchaseSection data-id="element-187" />
        </div>

        <TestimonialsSection data-id="element-188" />
      </main>

      <footer className="bg-[#1a1a1a] text-white py-8 text-center text-sm" data-id="element-189">
        <div className="max-w-6xl mx-auto px-4" data-id="element-190">
          <p className="opacity-60" data-id="element-191">
            © 2026 Guía para Hacer Esquejes. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-192" />
    </div>;
}